// Локальное хранение WB API-токена — единственный "ключ доступа" в сервисе,
// отдельного аккаунта/логина не существует.
export const WB_TOKEN_KEY = 'wb_token'

export const getStoredWbToken = (): string | null => localStorage.getItem(WB_TOKEN_KEY)

export const setStoredWbToken = (token: string) => localStorage.setItem(WB_TOKEN_KEY, token)

export const clearStoredWbToken = () => localStorage.removeItem(WB_TOKEN_KEY)
